<template>
  <div id="BaseNotAuthenticatedPage">
    <BaseHeader
      :theme="theme"
      :should-show-nav-icons="false"
      :should-show-search-controls="false"
      :should-show-main-menu="false"
    />
    <div class="container">
      <div class="row">
        <div class="col">
          <div v-if="customMessage">
            <h3>No Access</h3>
            <div class="alert alert-info">
              <p>{{ customMessage }}</p>
            </div>
            <h3>Please select an active dealer code:</h3>
            <AvailableDealerCodeSelector
              :show-all-branches-option="false"
              :show-label="false"
              class="bnap__dealer-code-selector"
              @selectDealerCode="SetUserDealerCode"
            />
          </div>
          <not-authorized v-else />
        </div>
      </div>
    </div>
    <BaseFooter
      :should-show-help-bar="true"
      :should-show-links="false"
    />
  </div>
</template>
<script>
  import { mapGetters } from "vuex"
  import BaseHeader from "@/components/Header/BaseHeader"
  import BaseFooter from "@/components/BaseFooter"
  import NotAuthorized from "@/components/Elements/NotAuthorized"
  import AvailableDealerCodeSelector from "@/components/Dropdowns/AvailableDealerCodeSelector"
  import { sessionHelper } from "@/components/mixins/sessionHelper"

  export default {
    components: {
      BaseHeader,
      BaseFooter,
      NotAuthorized,
      AvailableDealerCodeSelector
    },
    mixins: [sessionHelper],
    computed: {
      ...mapGetters(["user"])
    },
    props: {
      theme: {
        type: String,
        default: "Default"
      },
      customMessage: {
        type: String,
        default: ""
      }
    },
    methods: {
      SetUserDealerCode: function (selectedAvailableDealerCode) {
        if (selectedAvailableDealerCode.PrimaryDealerCode !== undefined) {
          const params = {
            dealerCode: selectedAvailableDealerCode.PrimaryDealerCode,
            isDn6: window.appGlobals.IS_DN6,
            sessionVarString: this.getSessionVarString(this.user.UserId),
            refreshAfterProcessing: false
          };
          this.$store.dispatch("UPDATE_DEALER_CODE", params).then(() => {
            window.location.reload();
          });
        }
      }
    }
  }

</script>

<style lang="scss">
  .bnap__dealer-code-selector{
    width: 450px;
    padding: 0px;
    margin: 0px;
    }

  @media (max-width: $screen-sm-max){
    .bnap__dealer-code-selector{
        width: 100%;
    }
  }
</style>
